// import { faWallet } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import React from 'react'

// const Coupon = ({title}) => {
//   return (
//     <div className='coupon'>
//         <div className='discountSticker'>
//             <div className='circleContainer'>
//             <div className='circle'></div>
//             <div className='circle'></div>
//             <div className='circle'></div>
//             <div className='circle'></div>
//             </div>
//             20% OFF
//         </div>
//         <div className='couponDetails'>
//             <div className='couponDetailsHeader'>
//                 <p><FontAwesomeIcon icon={faWallet} style={{marginRight: ".5rem", color: "purple"}} /> {title}</p>
//                 <button>Apply</button>
//             </div>
//             <p className='textGreen fs-small'>
//                 Lorem ipsum dolor sit amet consectetur adipisicing elit. Quibusdam, obcaecati!
//             </p>

//             <div className='expiryTimer'>
//                 <p>Expires in: <span></span></p>
//             </div>

//             <div className='seperator'>

//             </div>

//             <p className='txtGray fs-small'>
//                 Lorem ipsum dolor, sit amet consectetur adipisicing elit. Impedit, laborum!
//             </p>
//         </div>
//     </div>
//   )
// }

// export default Coupon

import { faWallet } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { handleCoupon } from '../../Utils/constants';

const Coupon = ({ title, coupon, setModalOpen, setCouponDetails, parentValues, params, handleCouponCodeResponse, setDrawerOpen, setApplyCouponErr, setApplyCouponLoading}) => {
    const expiryDate = new Date(coupon?.coupon_dynamic_end_date); 
    const [timeRemaining, setTimeRemaining] = useState(null);
    const [isCountdownActive, setCountdownActive] = useState(false);
    const [expired, setExpired] = useState(false);

    useEffect(() => {
        let interval;

        const checkExpiry = () => {
            const now = new Date();
            const remaining = expiryDate - now;

            if (remaining > 0) {
                if(expired) setExpired(false);
                setTimeRemaining(remaining);
                if (remaining < 24 * 60 * 60 * 1000 && !isCountdownActive) {
                    setCountdownActive(true);
                } else if (remaining >= 24 * 60 * 60 * 1000) {
                    setCountdownActive(false);
                }
            } else {
                setExpired(true)
                setTimeRemaining(null);
                clearInterval(interval);
            }
        };

        checkExpiry(); // Check immediately on mount

        interval = setInterval(checkExpiry, 1000); // Update every second

        return () => clearInterval(interval); // Cleanup
    }, [expiryDate, isCountdownActive]);

    const getTimeString = () => {
        if (isCountdownActive && timeRemaining !== null) {
            const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
            return <p>Expires in: <span>{hours}h {minutes}m {seconds}s</span></p>;
        }
        // return <p>Expires on: <span>{expiryDate.toLocaleString()}</span></p>;
       return <p>
        Expires in: {
          (() => {
            const today = new Date();
            const differenceInTime = expiryDate - today; // Difference in milliseconds
            const remainingDays = Math.ceil(differenceInTime / (1000 * 3600 * 24)); // Convert to days
            return remainingDays > 0 ? `${remainingDays} days` : 'Expired';
          })()
        }
        </p>
    };

    const handleApplyCoupon = async() => {

        console.log("In coupon params", params)
        // couponcode,
        // amountforcoupon,
        // planidforcoupon,
        // ogvalues,
        // DataStore,
        // coinsValue

        console.log("Params", params);

            
        setApplyCouponErr(null)
        setApplyCouponLoading(true)
        window.scrollTo(0,0);

        setTimeout(() => setModalOpen(true), 0);


        

       const res = await handleCoupon(coupon?.couponcode, coupon?.applicableDiscount, parentValues?.DataStore?.planid, parentValues?.ogvalues, parentValues?.DataStore, parentValues?.coinsValue, params, null)
      
       handleCouponCodeResponse(res);

       console.log("Apply coupon res --> ", res);

        if(!res?.error) {
            if(res?.data?.couponDetails) {
                setCouponDetails(res?.data?.couponDetails[0]);
                setTimeout(() => setModalOpen(true), 0);
                setDrawerOpen(false);
              }
        }

        if(res?.data?.errMessage) {
          
            setApplyCouponErr(res?.data?.errMessage)
            setTimeout(() => setModalOpen(false), 0);
            window.scrollTo(0, document.body.scrollHeight);
        }

        if(res?.notFoundErr === false) {
            setApplyCouponLoading(false);
            console.log("in apply coupon view component", res?.data?.errMessage)
            // setApplyCouponErr("TEST")
            setApplyCouponErr("Some error occurred")
            setTimeout(() => setModalOpen(false), 0);
            window.scrollTo(0, document.body.scrollHeight);
        }

        setApplyCouponLoading(false);
    }

    return (
        <div className={expired ? `coupon expired` : `coupon`}>
           
            <div className='discountSticker'>
                <div className='circleContainer'>
                    <div className='circle'></div>
                    <div className='circle'></div>
                    <div className='circle'></div>
                    <div className='circle'></div>
                </div>
                <p style={{color: "white"}}>
                {coupon?.flatorpercent == "flat" ? <span style={{fontWeight: "bold"}}>&#8377;{coupon?.value}</span> : coupon?.value+'%'} OFF 
                </p>
            </div>

            <div className='couponDetails'>
                <div className='couponDetailsHeader'>
                    <p>
                        <FontAwesomeIcon icon={faWallet} style={{ marginRight: ".5rem", color: "var(--global-theme)" }} />
                        {coupon?.couponcode}
                    </p>
                    <button className='cursor_pointer' disabled={expired} onClick={handleApplyCoupon}>Apply</button>
                </div>
                <p className='textGreen fs-small'>
                   Save {coupon?.flatorpercent == "flat" ? <span style={{fontWeight: "bold"}}>&#8377;{coupon?.value}</span> : coupon?.value+'%'} on this order!
                </p>

                <div className='expiryTimer'>
                    {!expired && getTimeString()}
                    {expired && <p>Expired</p>}
                </div>

                <div className='seperator'></div>

                <p className='txtGray fs-small'>
                    {coupon?.description}
                </p>
            </div>
        </div>
    );
};

export default Coupon;
